module.exports = __webpack_public_path__ + "img/square-this-way-up.ec451f76.svg";